module.exports = __webpack_public_path__ + "static/media/component-1.fc588976.svg";